<template>

    <div class="advisor-search-results-block container-fluid px-0">
        <div class="container" v-if="filteredAdvisors.length && !isInitializing && !isLoading">
            <div class="row results-amount-title">
                <div class="col-sm-12" v-html="results"></div>
            </div>
        </div>
        <div>
            <list-item v-for="(advisor) in filteredAdvisors.slice(0, endIndex)" :key="advisor.id" :advisor="advisor"
                :selectedAdvisorClick="selectAdvisorClickFn"></list-item>

            <div v-if="hasMoreAdvisors && !(isInitializing || isLoading)" class="py-3 container">
                <div class="row justify-content-center">
                    <div class="col-12 d-flex justify-content-center">
                        <a class="btn btn-primary text-center" href="javascript:;" @click="loadMoreClickFn">Load More</a>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!filteredAdvisors.length && !isInitializing && !isLoading && (isDirectConsumer.length || filteredAdvisors.length == 0)"
            class="advisor-search-page-zero-results py-3 container">
            <div class="row justify-content-center">
                <div class="col-12 text-center">
                    <p><span class="advisor-search-page-bold"> 0 results </span>found.</p>
                    <p>{{ text("advisorNameSearchNoResultsPrefix") }}<a href="javascript:;" @click="noResultsFoundFn">{{
            text("advisorNameSearchNoResultsLinkText") }}</a></p>
                </div>
            </div>
        </div>
        <div v-if="!filteredAdvisors.length && (isInitializing || isLoading)"
            class="advisor-search-page-zero-results py-3 container">
            <div class="row justify-content-center">
                <div class="col-12 text-center">
                    <div role="status" class="advisor-search-results-block-loading">
                        {{ text("loading") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import EventBus from "../functions/eventBus";
import ListItem from "./advisorListItem.vue";
import { locText } from "../../../utils/useText";

export default {
    created() {
        EventBus.$on("scrollToTop", () => {
            this.scrollToTop();
        });
    },
    data() {
        return {

        }
    },
    components: {
        "list-item": ListItem
    },
    computed: {
        isDirectConsumer: {
            get() {
                return this.$store.getters.isDirectConsumer;
            },
            set(value) {
                this.updateDirectConsumer(value);
            }
        },
        filteredAdvisors: {
            get() {
                return this.$store.getters.isDirectConsumer ? this.$store.getters.newConsumerDirect : this.$store.getters.filteredAdvisors;
            }
        },
        isInitializing: {
            get() {
                return this.$store.getters.isInitializing;
            }
        },
        isLoading: {
            get() {
                return this.$store.getters.isLoading;
            }
        },
        results() {
            return "<strong>" + this.endIndex + ' of ' + this.filteredAdvisors.length + "</strong> Results Shown";
        },
        selectedAdvisor: {
            get() {
                return this.$store.getters.selectedAdvisor;
            },
            set(value) {
                this.updateSelectedAdvisor(value);
            }
        },
        endIndex: {
            get() {
                return Math.min(this.$store.getters.currentPage * this.pageSize, this.filteredAdvisors.length);
            }
        },
        hasMoreAdvisors: {
            get() {
                return this.endIndex != this.filteredAdvisors.length;
            }
        }
    },
    mixins: [locText],
    methods: {
        ...mapActions(["updateSelectedAdvisor", "updateAdvisorsWithConsumer", "updateDirectConsumer", "incrementCurrentPage", "resetCurrentPage"]),

        scrollToTop() {
            var target = document.getElementsByClassName("sidebar-wrapper")[0];
            scrollTo(target, 0, 300);
        },
        scrollForNoResults() {
            if (this.$mq !== 'desktop') {
                setTimeout(() => {
                }, 0);
            }
        },
        scrollToTopMobile() {
            var target = document.getElementsByClassName("results-list-container")[0];
            scrollTo(target, int, 300);
        },
        selectAdvisorClickFn(advisor, clickLocale) {
            if (typeof HERO_analytics_data_layer != "undefined") {
                let analytics = HERO_analytics_data_layer,
                    name = advisor.firstName + " " + advisor.lastName,
                    event = {
                        event: "search",
                        search__type: "find-an-advisor-name",
                        search__term: name
                    };
                analytics.pushEventAndData(event);
            }

            // this.selectedAdvisor = advisor;
            // this.scrollToTop();
            window.location = advisor.advisorPageUrl;
        },
        loadMoreClickFn() {
            this.incrementCurrentPage()
        }

    },
    mixins: [locText],
    props: {
        noResultsFoundFn: Function,
        pageSize: Number
    },
    watch: {
        filteredAdvisors(newValue) {
            if (!newValue.length && !this.isLoading) {
                this.scrollForNoResults();
            } else {
                setTimeout(() => {
                    EventBus.scrollToTopMobile();
                }, 0);
            }
        }
    }
}
</script>
